(function () {
  'use strict';

  var productPath = '/products/offizielle-anti-stress-tasse-personalisierbar-mit-name-und-chilligen-tieren';
  var currentPath = window.location.pathname.replace(/\/$/, '');

  if (currentPath !== productPath) return;

  var normalize = function (value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  var requestedTier = normalize(new URLSearchParams(window.location.search).get('tier'));
  var allowedTiers = {
    dalmatiner: 'Dalmatiner'
  };

  if (!Object.prototype.hasOwnProperty.call(allowedTiers, requestedTier)) return;

  var targetName = normalize(allowedTiers[requestedTier]);

  function findTarget() {
    var root = document.querySelector('.tier-auswahl') || document.querySelector('#tee-artwork-form');

    if (!root) return null;

    var fields = root.matches('.tee-field--clipart')
      ? [root]
      : root.querySelectorAll('.tee-field--clipart');

    for (var fieldIndex = 0; fieldIndex < fields.length; fieldIndex += 1) {
      var images = fields[fieldIndex].querySelectorAll('img.tee-clipart-thumbnail[alt]');

      for (var imageIndex = 0; imageIndex < images.length; imageIndex += 1) {
        if (normalize(images[imageIndex].getAttribute('alt')) !== targetName) continue;

        var label = images[imageIndex].closest('label[for]');
        var input = label ? document.getElementById(label.htmlFor) : null;

        if (label && input && input.matches('input[type="radio"]')) {
          return { input: input, label: label };
        }
      }
    }

    return null;
  }

  function selectTier() {
    var target = findTarget();

    if (!target) return false;

    if (!target.input.checked) {
      target.label.click();
    }

    return true;
  }

  if (selectTier()) return;

  var attempts = 0;
  var interval = window.setInterval(function () {
    attempts += 1;

    if (selectTier() || attempts >= 50) {
      window.clearInterval(interval);
    }
  }, 300);
})();
